/**
 * Created by kisnows on 2017/9/4.
 */
const getDisplayName = component => component.displayName || component.name || 'Component'
export default getDisplayName
